<template>
  <DefaultLayout>
    <template #sidebar="{ collapsed }">
      <DefineButtonTemplate>
        <UButton
          icon="i-ph-arrow-left"
          label="Retour"
          color="neutral" variant="subtle"
          :to="`/group/${group.parent.id}/child`"
          :label="collapsed ? null : 'Retour'"
          :square="collapsed"
          v-if="backBtn" />
      </DefineButtonTemplate>
      <UTooltip v-if="collapsed" text="Retour" :content="{ side: 'right' }">
        <ReuseButtonTemplate />
      </UTooltip>
      <ReuseButtonTemplate v-else />
      <UNavigationMenu
        :collapsed="collapsed"
        :items="links"
        orientation="vertical"
        tooltip
        popover
      />
    </template>

    <template #default>
      <slot />
    </template>

  </DefaultLayout>
</template>

<script setup>
import DefaultLayout from './default.vue'

const group = useState('group')
const isAdmin = useState('isAdmin')

const [DefineButtonTemplate, ReuseButtonTemplate] = createReusableTemplate()

const links = computed(() => {
  if (!group.value) {
    return [];
  }

  let links = [{
    id: 'organizations',
    label: 'Structures',
    icon: 'i-ph-users-three-duotone',
    to: `/group/${group.value.id}/organization`,
  }]

  if (group.value.type === 'city' || group.value.parent) {
    links.push({
      id: 'missions',
      label: `Missions${group.value.data.allow_activities || group.value.data.allow_events ? ' de Bénévolat' : ''}`,
      icon: 'i-ph-megaphone-duotone',
      to: `/group/${group.value.id}/mission`,
    })
  } else {
    links.push({
      id: 'missions',
      label: 'Missions',
      icon: 'i-ph-megaphone-duotone',
      defaultOpen: true,
      children: [{
        label: 'Missions des structures',
        to: `/group/${group.value.id}/mission`,
      }, {
        label: 'Modèles de mission',
        to: `/group/${group.value.id}/mission-template`,
      }]
    })
  }

  if (group.value.data.allow_activities) {
    links.push({
      id: 'activities',
      label: 'Activités',
      icon: 'i-ph-person-simple-run-duotone',
      to: `/group/${group.value.id}/activity`,
    })
  }

  if (group.value.data.allow_events) {
    links.push({
      id: 'events',
      label: 'Événements',
      icon: 'i-ph-calendar-dots-duotone',
      to: `/group/${group.value.id}/event`,
    })
  }

  if (!group.value.parent && group.value.type === 'network') {
    links.push({
      id: 'child',
      label: 'Groupes',
      icon: 'i-ph-network-duotone',
      to: `/group/${group.value.id}/child`,
    })
  }

  const settings = [{
    label: 'Général',
    to: `/group/${group.value.id}/settings`,
    exact: true
  }]

  if (!group.value.parent || !group.value.parent.subscriptions.length) {
    settings.push({
      label: 'Abonnement',
      to: `/group/${group.value.id}/settings/subscription`,
    })
  }

  settings.push({
    label: 'Gestion des accès',
    to: `/group/${group.value.id}/settings/permission`,
  })

  if (group.value.platform && group.value.parent) {
    settings.push({
      label: 'Créer un widget',
      to: `/widget-configurator?url=https://${group.value.platform.domain}&group=${group.value.id}`,
      external: true,
      target: '_blank',
    })
  }

  if (group.value.network?.pipedrive_id && isAdmin.value) {
    settings.push({
      label: 'Fiche Pipedrive',
      to: `https://benevolt.pipedrive.com/organization/${group.value.network.pipedrive_id}`,
      external: true,
      target: '_blank',
      class: 'text-admin',
    })
  }

  links.push(...[{
    id: 'stats',
    label: 'Statistiques',
    to: `/group/${group.value.id}/stats`,
    icon: 'i-ph-chart-pie-slice-duotone',
  }, {
    id: 'settings',
    label: 'Paramètres',
    icon: 'i-ph-gear-duotone',
    defaultOpen: true,
    children: settings,
  }])

  if (group.value.platform && (useState('profile').value.platforms.find((p) => p.id === group.value.platform.id) || useState('profile').value.account_type === 'admin' || useState('isAdmin').value)) {
    links = [links, [{
      label: 'Gérer la plateforme',
      to: `/platform/${group.value.platform.id}`,
      icon: 'i-ph-arrow-square-in',
    }]]
  }

  return links
})

const backBtn = computed(() => group.value?.parent && (
  useState('profile').value.account_type === 'admin' || useState('isAdmin').value || useState('profile').value.groups.find((g) => g.id === group.value.parent.id)
))

</script>
